<script lang="ts" generics="T">
  import { Check } from "lucide-svelte"
  import { xhr, toast, blankOrValue } from "$app/utils"
  import Honeybadger from "$app/utils/honeybadger"
  import Tiptap from "$app/components/Tiptap.svelte"
  import { onlyTextButtons } from "$app/components/Tiptap/buttons"
  import Task from "$app/Pages/Plans/Activities/Index/Task.svelte"

  type typeType = "text" | "number" | "textarea"
  // Props
  let {
    value = $bindable(),
    type = "text",
    postURL = "",
    model = "",
    name = "",
    placeholder = "",
    onsuccess = () => {}
  }: {
    value: string | number
    type?: typeType
    postURL: string
    model: string
    name: string
    placeholder?: string
    onsuccess?: (data: T) => void
  } = $props()

  const initialVal = JSON.parse(JSON.stringify(value))
  let copyValue = $state(JSON.parse(JSON.stringify(value)))

  let editing = $state(false)
  let inputEl = $state<HTMLInputElement | null>(null)

  const handleEnter = (e: KeyboardEvent) => {
    if (e.key === "Enter") {
      inputEl.blur()
    }
  }
  function init(el) {
    el.focus()
  }

  let showSaved = $state(false)
  function toggleSaved() {
    showSaved = true
    setTimeout(() => (showSaved = false), 1000)
  }

  let saving = $state(false)
  let save_timeout = $state(null)

  function save() {
    clearTimeout(save_timeout)
    save_timeout = setTimeout(() => {
      handleSave()
    }, 600)
  }

  async function handleSave(): Promise<void> {
    if (initialVal === copyValue) return

    saving = true

    const data = { [model]: { [name]: copyValue } }
    try {
      const resp = await xhr.patch<T>(postURL, data)

      toggleSaved()
      value = JSON.parse(JSON.stringify(copyValue))
      onsuccess(resp.data)
    } catch (e: any) {
      if (typeof Honeybadger.notify !== "undefined") {
        Honeybadger.notify(e)
      }
      const errors = e.response.data.errors

      if (errors && errors[name]) {
        toast(errors[name], "error")
      } else {
        toast("There was an error saving", "error")
      }
    } finally {
      saving = false
    }
  }
</script>

<div class="relative">
  {#if editing && ["text", "number"].includes(type)}
    <div class="mt-1 relative rounded-md shadow-sm">
      <input
        class="px-2 py-0.5 block w-full shadow-sm focus:ring-blue-400 focus:border-blue-400 border-gray-300"
        bind:this={inputEl}
        {type}
        bind:value={copyValue}
        {placeholder}
        onblur={handleSave}
        onkeyup={handleEnter}
        use:init
      />
    </div>
  {:else if editing && type === "textarea"}
    <div class="mt-1 shadow-sm border-dashed rounded border-gray-100">
      <Tiptap
        {placeholder}
        content={value}
        onupdate={({ html }) => (value = html)}
        onblur={handleSave}
        buttons={onlyTextButtons}
      />
    </div>
  {:else}
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <div
      class="w-full p-1 border-dashed border-b border-blue-200 cursor-pointer hover:bg-gray-50"
      onclick={() => (editing = true)}
      role="button"
      tabindex="0"
    >
      {@html blankOrValue(String(value), placeholder)}
    </div>
  {/if}
  <span class="absolute top-0 right-2" class:hidden={!showSaved}>
    <Check class="text-green-500" />
  </span>
</div>
